import { Injectable } from "@angular/core";
import { MCAuthoritiesFieldUtils, MCCustomFunctionsParams } from "@maslul/common-services";
import { TABS } from "../../../../enum/request/TABS";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesFieldUtils extends MCAuthoritiesFieldUtils {

    override setFormStateProperty(customFunctionsObj: MCCustomFunctionsParams, key: string, value: any): void {
        customFunctionsObj.formisForm.setFormStateProperty(key, value, TABS.PRODUCTS);
    }
}
